import {
  getAssignedDepartmentList,
  getDepartmentNamesArray,
  getItemOrDefaultToValue,
  getPersonName,
  getPhoneNumber,
} from '../../details';

export const transform = ({ list, globalDepartmentList = [] }) => {
  return list.map(data => ({
    id: data.general.id,
    archived: data.details.archived,
    employeeId: getItemOrDefaultToValue(data.general, 'employeeId', '-'),
    role: getItemOrDefaultToValue(data.general, 'roles', ['-'])[0],
    name: getPersonName(data.general),
    phone:
      data.general.phoneNumber !== null
        ? getPhoneNumber(data.general.phoneNumber)
        : '-',
    email: getItemOrDefaultToValue(data.general, 'email', '-'),
    businessClient: getItemOrDefaultToValue(
      data.general,
      'businessClientName',
      '-',
    ),
    businessClientId: getItemOrDefaultToValue(
      data.general,
      'businessClientId',
      '-',
    ),
    emailVerified: data.details
      ? getItemOrDefaultToValue(
          data.details.verifications,
          'emailVerified',
          false,
        )
      : false,
    phoneVerified: data.details
      ? getItemOrDefaultToValue(
          data.details.verifications,
          'phoneVerified',
          false,
        )
      : false,
    status: data.operational
      ? getItemOrDefaultToValue(data.operational, 'status', 'inactive')
      : 'inactive',
    // this gives array of string names
    departments:
      data.general?.departmentIds && globalDepartmentList.length > 0
        ? getDepartmentNamesArray(globalDepartmentList, data)
        : [],
    // this give array of objects with string name and ids
    assignedDepartmentList:
      data.general?.departmentIds && globalDepartmentList.length > 0
        ? getAssignedDepartmentList(globalDepartmentList, data)
        : [],
  }));
};

export const transformRawClient = list => {
  return list.map(item => ({
    pageName: '/people/customers',
    label: getPersonName(item.general),
    value: item,
    id: item.general.id,
    status: getItemOrDefaultToValue(item.operational, 'status'),
    qualifications:
      item.details.qualifications != null
        ? getItemOrDefaultToValue(item.details, 'qualifications')
        : [],
    services: getItemOrDefaultToValue(item.details, 'services', []),
  }));
};
